import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbDatepickerI18n
} from '@ng-bootstrap/ng-bootstrap';
import { CustomAdapterService } from './services/custom-adapter.service';
import { CustomDateParserFormatterService } from './services/custom-date-parser-formatter.service';
import { CustomDatepickerI18nService } from './services/custom-datepicker-i18n.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: NgbDateAdapter, useFactory: () => new CustomAdapterService() },
    {
      provide: NgbDateParserFormatter,
      useFactory: () => new CustomDateParserFormatterService()
    },
    {
      provide: NgbDatepickerI18n,
      useClass: CustomDatepickerI18nService
    }
  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule has already been loaded. You should only import Core modules in the AppModule only.'
      );
    }
  }
}
